import { call, put } from 'redux-saga/effects';

import { createWorkflowDraft } from 'api/WorkflowsAPI';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { parseWorkflowForSaving } from '../../utils';
import { CreateWorkflowDraftRequestAction, actions } from '../actions';

export default function* createWorkflowDraftSaga(action: CreateWorkflowDraftRequestAction) {
  const successMessage = 'Success! Draft added for this journey.';
  const errorMessage = 'Sorry, unable to create draft.';

  try {
    const { workflow } = action.payload;
    const updatedWorkflow = parseWorkflowForSaving(workflow);
    yield put(actions.updateIsAsyncLoading(true));
    const { data, errors } = yield call(createWorkflowDraft, updatedWorkflow);
    if (errors?.length) {
      yield put(actions.updateIsAsyncLoading(false));
      yield put(actions.saveWorkflowError());
      yield put(addNegativeToastWithErrorId(errorMessage, 'createWorkflowDraft'));
      return;
    }

    const { createWorkflowDraft: createWorkflowDraftResponse } = data;
    const { nodes = [] } = createWorkflowDraftResponse;

    yield put(actions.updateHasUnsavedChanges(false));
    yield put(actions.createWorkflowDraftResponse({ ...createWorkflowDraftResponse, nodes }));
    yield put(actions.updateIsAsyncLoading(false));
    yield put(addPositiveToast(successMessage));
  } catch (error) {
    yield put(actions.updateIsAsyncLoading(false));
    yield put(actions.saveWorkflowError());
    yield put(addNegativeToastWithErrorId(errorMessage, 'createWorkflowDraft'));
  }
}
